const updateStatus = `
  mutation updateEnterpriseTreatmentPlaceTransactionStatus($data: EnterpriseTreatmentPlaceTransactionUpdateInput!,  $where: EnterpriseTreatmentPlaceTransactionWhereUniqueInput!) {
    updateEnterpriseTreatmentPlaceTransactionStatus(data: $data, where: $where) {
        etptId
    }
  }
`

export { updateStatus }
